// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "mail." + chunkId + "." + {"8":"aa9110f693d99058ed3c","66":"9567446a410ba44fca77","176":"370c4f4bfc02ce446715","471":"bdf7ee551f1a2e6dfc94","862":"856324fd144da45d0628"}[chunkId] + ".js";
};